const PREFS_KEY = 'shipment_recorder_prefs';

export const getPreferences = () => {
  try {
    const stored = localStorage.getItem(PREFS_KEY);
    if (stored) return JSON.parse(stored);
  } catch (e) {
    console.warn('Failed to load preferences:', e);
  }
  return { downloadToPC: true, uploadToCloud: false, brandName: 'ShareMyImage.com', cameraOn: true };
};

export const savePreferences = (prefs) => {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch (e) {
    console.warn('Failed to save preferences:', e);
  }
};